import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

window.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector(".HeaderComponent")

    const showAnim = gsap.from(header, {
        yPercent: -100,
        paused: true,
        duration: 0.5,
    }).progress(1);

    const trigger = ScrollTrigger.create({
        start: "top top",
        end: "max",
        onUpdate: (self) => {
            self.direction === -1 ? showAnim.play() : showAnim.reverse()
        }
    });

    window.addEventListener('spinEnd', () => {
        trigger.refresh();
    });

    const headerLogo = document.querySelector(".HeaderComponent .HeaderLogoScroll")

    function scrollToTop() {
        gsap.to(window, {
            duration: 0.5,
            scrollTo: 0,
            ease: "power1.inOut",
        })
    }

    if (headerLogo) {
        headerLogo.addEventListener("click", scrollToTop)
    }
});